var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"Yeni Grup Tur Rezervasyonu","title":_vm.pageTitle}}),_c('div',{staticClass:"container-fluid tur-rezervasyon-duzelt"},[_c('GrupTurRezervasyonForm',{attrs:{"acenteId":_vm.id},on:{"onComplete":_vm.onComplete}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }